import React from 'react'
import { UploadCompanyFileFlowProvider } from './context/UploadCompanyFileFlowProvider'
import { UploadCompanyFileFlowMain } from './components/UploadCompanyFileFlowMain'

export const UploadCompanyFileFlow = () => {
  return (
    <UploadCompanyFileFlowProvider>
      <UploadCompanyFileFlowMain />
    </UploadCompanyFileFlowProvider>
  )
}
